/**
 * Format a price to a currency string
 * 
 * @param {*} value 
 * @returns 
 */
export const formatPrice = (value) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
    });
    return formatter.format(value);
};

/**
 * Format an academic year to a string
 * 
 * @param {*} startYear
 * @param {*} endYear 
 * @param {*} short 
 * @returns 
 */
export const formatAcademicYear = (startYear, endYear, short = false) => {
    if (short) {
        return `${startYear}/${String(endYear).slice(-2)}`;
    }
    return `${startYear}/${endYear}`;
};